// =====================
// Runtime implementations
// =====================

const sharedMethods = {
  ready(cb) {
    if (document.readyState !== "loading") cb();
    else document.addEventListener("DOMContentLoaded", cb);
    return this;
  },

  log() {
    // console.log(this);
    return this;
  },
};

const elementMethods = {
  html(content) {
    if (content === undefined) return this.innerHTML;
    this.innerHTML = content;
    if (this.id === "app") {
      window.dispatchEvent(new Event("appChanged"));
    }
    return this;
  },

  highlight(color = "yellow") {
    this.style.backgroundColor = color;
    return this;
  },

  on(evt, cb) {
    this.addEventListener(evt, cb);
    return this;
  },

  off(evt, cb) {
    this.removeEventListener(evt, cb);
    return this;
  },
  removeAttr(attrName) {
    if (this.hasAttribute(attrName)) {
      this.removeAttribute(attrName);
      return true;
    }
    return false;
  },
};

const noneSelectorMethods = {
  addStyle(href) {
    const hrefFragments = href.split("/");
    const id = hrefFragments[hrefFragments.length - 1].replace(".css", "");

    const stylesheet = document.createElement("link");
    stylesheet.setAttribute("type", "text/css");
    stylesheet.setAttribute("rel", "stylesheet");
    stylesheet.setAttribute("href", href);
    stylesheet.setAttribute("id", id);
    document.querySelector("head").appendChild(stylesheet);
  },
  removeStyle(id) {
    if (document.querySelector(id)) {
      document.querySelector(id).remove();
    } else {
      // console.warn("The stylesheet id was not found");
    }
  },
};

// =====================
// Implementation
// =====================

function _(selector) {
  // Window / Document
  if (selector === window || selector === document) {
    return createProxy(selector);
  }

  // HTMLElement
  if (selector instanceof HTMLElement) {
    return createProxy(selector);
  }

  // CSS selector
  if (typeof selector === "string") {
    const elements = document.querySelectorAll < HTMLElement > selector;

    if (elements.length === 0) return null;

    // Multiple elements → collection proxy
    if (elements.length > 1) {
      return new Proxy(elements, {
        get(target, prop) {
          if (prop in elementMethods || prop in sharedMethods) {
            return (...args) => {
              target.forEach((el) => [prop]?.apply(el, args));
              return target;
            };
          }
          return [prop];
        },
      });
    }

    // Single element
    return createProxy(elements[0]);
  }
  return noneSelectorMethods;
}

function createProxy(target) {
  const methods =
    target instanceof HTMLElement
      ? { ...sharedMethods, ...elementMethods }
      : sharedMethods;

  return new Proxy(target, {
    get(t, prop) {
      if (prop in methods) return methods[prop].bind(t);
      return [prop];
    },
  });
}

export default _;
